<template>
<!--  <Panel :header="(isWarrantyPanel ? $t('complaintsLabel') : $t('salesByEmployeeLabel')) + (periodLabel ? ' (' + periodLabel + ')' : '')"-->
<!--         toggleable-->
<!--         :collapsed="isCollapsed"-->
<!--         @toggle="togglePanel">-->
  <Panel toggleable :collapsed="isCollapsed" @toggle="togglePanel">
    <template #header>
      <div class="statistics-panel-header">
        <b>{{ isWarrantyPanel ? $t('complaintsLabel') : $t('salesByEmployeeLabel') }}</b>
        <span v-if="periodLabel" class="p-text-secondary statistics-panel-date p-mr-2">
          {{ periodLabel }}
        </span>
      </div>
    </template>
    <div v-if="showSearchInput" class="p-mb-3">
      <SearchInput :changeUrl="false"
                   ref="searchInput"
                   @search-items="searchStatistics"
                   :disabled="showSpinner"
                   v-model="searchData"/>
      <!--      <hr>-->
    </div>
    <Spinner v-if="showSpinner" :isSmall="true" :spinnerStyle="'margin: 20px auto'"/>
    <template v-else-if="managerSales?.length">
      <div v-for="(manager, index) of managerSales"
           :key="index"
           class="datatable-wrapper"
           :class="{'p-mt-5': managerSales.length > 1 && index > 0}">
        <ManagerSalesPanelTable :fromTimestamp="fromTimestamp"
                                :toTimestamp="toTimestamp"
                                :isWarrantyPanel="isWarrantyPanel"
                                :manager="manager"
                                :searchData="appliedSearchData"/>
      </div>
    </template>
    <div v-else style="text-align: center; padding: 20px;">
      {{ $t('No data available' )}}
    </div>
  </Panel>
</template>

<script>
import ManagerSalesPanelTable from "@/pages/overview/components/ManagerSalesPanelTable";
import httpClient from "@/services/http.services";
import showErrorsMixins from "@/mixins/showErrorsMixins";

export default {
  mixins: [ showErrorsMixins ],
  components: { ManagerSalesPanelTable },
  name: 'ManagerSalesPanel',
  props: {
    periodLabel: { type: String, default: '' },
    // managerSales: {
    //   type: Array,
    // },
    isWarrantyPanel: {
      type: Boolean,
      default: false,
    },
    dataTableIsLoading: {
      type: Boolean,
      default: false
    },
    fromTimestamp: {
      type: Number,
      default: null
    },
    toTimestamp: {
      type: Number,
      default: null
    },
  },
  watch: {
    dataTableIsLoading(boolean) {
      if (boolean) {
        this.isCollapsed = true
      }
    },
  },
  data: () => {
    return {
      searchData: '',
      appliedSearchData: '',
      managerSales: [],
      showSpinner: false,
      isCollapsed: true,
    }
  },
  methods: {
    searchStatistics() {
      this.appliedSearchData = this.searchData ? this.searchData.trim() : ''
      this.getStatistics()
    },
    togglePanel(event) {
      if (!event) return
      const value = !event.value
      this.isCollapsed = !value
      if (value) {
        this.getStatistics()
      } else {
        this.searchData = ''
        this.appliedSearchData = ''
        this.managerSales = []
        this.$refs.searchInput?.clearLastSearchingValue()
      }
    },
    async getStatistics() {
      if (this.showSpinner) return

      this.showSpinner = true
      try {
        const { status, data } = await httpClient({
          url: 'statistics/get-manager-sales-statistics',
          method: 'post',
          // params: {
          data: {
            dateFrom: this.fromTimestamp,
            dateTo: this.toTimestamp,
            showWarrantyOnly: this.isWarrantyPanel,
            search: this.appliedSearchData ? this.appliedSearchData.trim() : null,
          }
        })

        if (status === 200 && data) {
          this.managerSales = data.manager_sales || []
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.showSpinner = false
      }
    },
  },
  computed: {
    hasManagerSales() {
      return Array.isArray(this.managerSales) && this.managerSales.length > 0
    },

    hasSearch() {
      return !!(this.searchData && this.searchData.trim())
    },

    showSearchInput() {
      return this.hasManagerSales || this.hasSearch
    }
  }
}
</script>

<style scoped lang="scss">
.datatable-wrapper {
  overflow-y: auto;
}
</style>